module.exports = __webpack_public_path__ + "static/img/sjtj_hover.3918ec99.gif";